export enum editMode{
    no = 0,
    yes = 1,
  }